<script lang="ts">
	import { TextRowSelector } from "misc-ui"
	import GroupSettings from "../../GroupSettings.svelte"
	import InputsSlotPriority from "./Inputs_SlotPriority.svelte"
	import InputsSlotProperties from "./Inputs_SlotProperties.svelte"
	import { GroupEditorController } from "../../../GroupEditorController"
	import type { DeviceGroupSlot } from "luxedo-data"

	const MENUS = {
		Priority: InputsSlotPriority,
		Properties: InputsSlotProperties,
		Group: GroupSettings,
	}

	type MenuName = keyof typeof MENUS

	let selectedSlot: DeviceGroupSlot = $state()
	let availableMenus = $derived(
		selectedSlot ? ["Priority", "Properties", "Group"] : ["Priority", "Group"],
	)

	let selectedMenu: MenuName = $state("Priority")
	let Menu = $derived(MENUS[selectedMenu])

	GroupEditorController.Slots.subscribe((ctx) => {
		selectedSlot = ctx.slots.find((slot) => ctx.selectedSlot === slot.id)
	})

	function onSelect(menu: MenuName) {
		selectedMenu = menu
	}
</script>

<div id="group-align-inputs">
	<TextRowSelector options={availableMenus} onChange={onSelect} selectedOption={selectedMenu} />
	<Menu />
</div>

<style>
	#group-align-inputs {
		padding: 1rem 1rem 0 1rem;
		display: flex;
		flex-direction: column;
	}

	#group-align-inputs :global(.text-row-selector) {
		margin-bottom: 0.5rem;
	}

	#group-align-inputs :global(.slot-properties-container) {
		padding: 0;
		height: 100%;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	#group-align-inputs :global(.slot-properties) {
		overflow-y: auto;
		flex-wrap: wrap;
		gap: 0.5rem;
	}

	#group-align-inputs :global(.group-align-heading) {
		justify-content: space-between;
	}

	#group-align-inputs :global(.slot-priority-container) {
		padding: 0;
	}
</style>
